import { Module } from "vuex";
import { RootState, FridgeDetailsState } from "@/types/fridgeDetails";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: FridgeDetailsState = {
  econaviInfo: null,
  doorOpenInfo: null,
  pushSettings: null,
  reductoinInfo: null,
  settings: null,
  operationSettings: null,
  functionList: null,
  settingsBuffer: null,
  pushSettingsBuffer: null,
  myAssist: null,
  coolingAssisySettings: null,
  coolingAssisttopTabIdex: null,
  doorMonitorTabIndex: null,
  doorMonitorDailyTabIndex: null,
  descriptionList: null,
  settingsInitialValue: null
};

export const fridgeDetails: Module<FridgeDetailsState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
